import React , { useState , useEffect , useRef } from "react";
import { Container , Row , Col } from "react-bootstrap";
import "./cityapp.css"
import { cityAxios } from "../axiosbase/axios_base/axiosconfig";
import HeadBar from "../headbar/headbar";
import locationIcon from "../../images/location-icon.png"

export default function City(){

    const [allcountries , setAllCountries] = useState()
    const [states , setStates] = useState()
    const [cities , setCities] = useState()
    const [location , setLocation] = useState({
        country:"",
        state:"",
        city:""
    })
    const countryRef = useRef()
    const stateRef = useRef()
    const cityRef = useRef()


    const countryText = countryRef.current ? countryRef.current?.options[countryRef.current.selectedIndex].textContent : ""
    const stateText = stateRef.current?.value ? `, ${stateRef.current?.options[stateRef.current.selectedIndex].textContent}` : ""
    const cityText = (stateText && cityRef.current?.value) ? `, ${cityRef.current?.options[cityRef.current.selectedIndex].textContent}` : ""

    useEffect(() => {
        cityAxios.get("/allcountries")
            .then((res) => setAllCountries(res.data))
            .catch((err) => console.log(err))
    }, [])
    
    useEffect(() => {
        setLocation((prev) => {
            return {...prev,state:"",city:""}
        })
        setCities([])
        setStates([])
        if (location.country) {
            cityAxios.get("/states-by-countrycode" , {params: {
                countrycode: location.country
            }})
                .then((res) => {
                    setStates(res.data)
                })
                .catch((err) => {
                    console.log(err)
                })
        }
        if (!location.country) {
            setLocation(prev => {return {country:"",state:"",city:""}})
        }
    }, [location.country])

    useEffect(() => {
        setLocation((prev) => {
            return {...prev,city:""}
        })
        setCities([])
        if(location.state?.length > 0) {
            cityAxios.get("/cities-by-countrycode-and-statecode" , {params: {
                countrycode: location.country,
                statecode: location.state
            }})
                .then((res) => {
                    setCities(res.data)
                })
                .catch((err) => console.log(err))
        }
    }, [location.state])

    const countryOptions = allcountries?.map((country , i) => {
        return (
            <option key = {i} value = {country.isoCode}>
                { country.name }
            </option>
        )
    })

    const stateOptions =  states?.map((state , i) => {
        return (
            <option key = {i} value = {state.isoCode}>
                { state.name }
            </option>
        )
    })

    const cityOptions = cities?.map((city,i) => {
        return (
            <option key = {i} value = {city.name}>
                { city.name }
            </option>
        )
    })

    const locationChanger = ( area , value ) => {
        setLocation((prev) => { 
            return {
                ...prev,
                [area]:value
            }
        })
    }

    return (
        <>
            <HeadBar 
                headText = {`This page was built with the "Country State City" REST API.`}
                apiLink = "https://rapidapi.com/rapihub-rapihub-default/api/country-state-city-search-rest-api/"
                apiImg = "https://rapidapi.com/cdn/images?url=https://rapidapi-prod-apis.s3.amazonaws.com/84d4dfe7-5c74-441f-acf8-8251954021c4.jpg"
            />
            <Container
                className = "city-app-container"
            >
                <Row>
                    <Col
                        className = "text-and-icon-col"
                    >
                        <img 
                            className = "location-icon-img"
                            src = { locationIcon } 
                            alt = "location-icon" 
                        />
                        <h2
                            className = "location-text"
                        >
                            {countryText + stateText + cityText}
                        </h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Row>
                            <Col>
                                <label htmlFor="country">Country:</label>
                                <select name = "country" ref = {countryRef} value = {location.country} onChange={(e) => locationChanger("country",e.target.value)}>
                                    <option key = "empty" value = "">  
                                        Choose a country
                                    </option>
                                    { countryOptions }
                                </select>
                            </Col>
                        </Row>
                        { states?.length > 0 && 
                            <Row>
                                <Col>
                                    <label htmlFor="state">State:</label>
                                    <select name="state" ref = {stateRef} value = {location.state} onChange={(e) => locationChanger("state",e.target.value)}>
                                        <option key = "empty" value = "">  
                                            Choose a state                              
                                        </option>
                                        { stateOptions }
                                    </select>
                                </Col>
                            </Row>
                        }
                        { cities?.length > 0 &&
                            <Row>
                                <Col>
                                    <label htmlFor="city">City:</label>
                                    <select name="city" ref = {cityRef} value = {location.city} onChange={(e) => locationChanger("city",e.target.value)}>
                                        <option key = "empty" value = "">  
                                            Choose a city
                                        </option>
                                        { cityOptions }
                                    </select>
                                </Col>
                            </Row>
                        }
                    </Col>
                </Row>
            </Container>
        </>
    )
}